import { db } from '../database';
export { addProduct };
function addProduct(ingredient, recipeId, index) {
    const product = ingredient.product;
    void db.transaction('rw', db.products, db.ingredients, () => {
        void db.products.put({
            ...product,
            id: product.id,
        });
        void db.ingredients.add({
            ...ingredient,
            recipe_id: recipeId,
            product_id: product.id,
            index: index,
        });
    });
}
